import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

/** Errore di caricamento con "Riprova". Mai al posto di uno stato vuoto:
 * "nessuna pratica" e "non riesco a caricarle" sono due cose diverse, e
 * confonderle trasforma un guasto in un'informazione falsa (audit RMA #21). */
export function LoadError({ message, onRetry, testId }: { message: string; onRetry: () => void; testId?: string }) {
  return (
    <div className="rounded-xl border border-rose-200 bg-rose-50 p-6 text-center" data-testid={testId}>
      <AlertTriangle className="w-6 h-6 text-rose-600 mx-auto mb-2" />
      <p className="text-sm text-rose-800 mb-3">{message}</p>
      <button
        onClick={onRetry}
        className="h-8 px-3 rounded-lg border border-rose-300 bg-white text-xs font-medium text-rose-800 hover:bg-rose-100 inline-flex items-center gap-1.5"
      >
        <RotateCcw className="w-3.5 h-3.5" /> Riprova
      </button>
    </div>
  );
}
